import dayjs from 'dayjs'
import { getStartOfWeek } from './getStartOfWeek'

export function getWeekdaysNames() {
    const names = ["Seg", "Ter", "Qua", "Qui", "Sex", "Sáb", "Dom"]

    return names
}
